import React, { CSSProperties, useState } from 'react'
import useSettingsV2 from '../hooks/useSettingsV2'

interface IProps {
  onClick: () => void
  label: string
  labelSuccess?: string
  style?: CSSProperties
  disabled?: boolean
}

const Button = ({ onClick, label, labelSuccess, style, disabled }: IProps) => {
  const { settings } = useSettingsV2() as any

  const [loading, setLoading] = useState(false)
  const [success, setSuccess] = useState(false)

  return (
    <button
      style={{ backgroundColor: settings?.bgPrimaryColor, ...style }}
      type="button"
      className={`button is-primary ${loading && 'is-loading'}`}
      onClick={async () => {
        setLoading(true)
        await onClick()
        setSuccess(true)
        setLoading(false)
      }}
      disabled={success || disabled}
    >
      {success && labelSuccess ? labelSuccess : label}
    </button>
  )

  // return (
  //   <Button2
  //     disabled={success || disabled}
  //     type="primary"
  //     loading={loading}
  //     htmlType="button"
  //     onClick={async () => {
  //       setLoading(true)
  //       await onClick()
  //       setSuccess(true)
  //       setLoading(false)
  //     }}
  //   >
  //     {success && labelSuccess ? labelSuccess : label}
  //   </Button2>
  // )
}

export default Button
